import React from 'react';
import { Phone } from 'lucide-react';
export function CTABanner() {
  return <section className="py-24 relative overflow-hidden" data-id="element-18">
      {/* Background Image */}
      <div className="absolute inset-0" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1556912167-f556f1f39fdf?auto=format&fit=crop&q=80")',
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat'
    }} data-id="element-19"></div>

      {/* Blue Overlay */}
      <div className="absolute inset-0 bg-brand-blue/70" data-id="element-20"></div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-21">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-22">
          Ready to Start Your Project?
        </h2>
        <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto font-body" data-id="element-23">
          Get a free, no-obligation quote from a licensed Fresno contractor.
          We'll discuss your vision, timeline, and budget.
        </p>

        <div className="flex flex-col items-center space-y-6" data-id="element-24">
          <a href="#contact" className="bg-brand-blue hover:bg-opacity-90 text-white px-10 py-4 rounded font-semibold text-xl transition-colors shadow-lg w-full sm:w-auto" data-id="element-25">
            Get a Free Quote
          </a>

          <div className="flex items-center text-white" data-id="element-26">
            <span className="text-gray-400 mr-3" data-id="element-27">Or call us directly:</span>
            <a href="tel:559-288-0499" className="flex items-center font-semibold text-xl hover:opacity-80 transition-colors" data-id="element-28">
              <Phone className="w-5 h-5 mr-2" data-id="element-29" />
              559-288-0499
            </a>
          </div>
        </div>
      </div>
    </section>;
}